const userTypes ={
    CREATE_GROUP: "CREATE GROUP",
    GET_GROUPS: "GET GROUPS",
    JOIN_GROUP: "JOIN GROUP",
    GET_MEMBERS: "GET MEMBERS"

    
}
export default userTypes